(function ($, Drupal) {

  // function addToCalInit() {
  //   if (window.addtocalendar) {if (typeof window.addtocalendar.start == 'function') {return;}}
  //   if (window.ifaddtocalendar == undefined) {
  //     window.ifaddtocalendar = 1;
  //     var d = document, s = d.createElement('script'), g = 'getElementsByTagName';
  //     s.type = 'text/javascript'; s.charset = 'UTF-8'; s.async = true;
  //     s.src = 'https://addtocalendar.com/atc/1.5/atc.min.js';
  //     var h = d[g]('body')[0]; h.appendChild(s);
  //   }
  //   console.log('hi');
  // }

  // $(document).on('ready', function () {
  //   addToCalInit();
  // });


  Drupal.theme.ajaxProgressIndicatorFullscreen = function () {
    return '<div class="ajax-progress ajax-progress--fullscreen"><div class="ajax-progress__inner">&nbsp;</div></div>';
  };

  Drupal.theme.ajaxProgressThrobber = function (message) {
    var messageMarkup = typeof message === 'string' ? Drupal.theme('ajaxProgressMessage', message) : '';
    var throbber = '<div class="ajax-progress__throbber">&nbsp;</div>';
    return "<div class=\"ajax-progress ajax-progress--throbber\">".concat(throbber).concat(messageMarkup, "</div>");
  };

  Drupal.theme.ajaxProgressMessage = function (message) {
    return "<div class=\"ajax-progress__message\">".concat(message, "</div>");
  };

}(jQuery, Drupal));
